import { render, staticRenderFns } from "./FullVideo.vue?vue&type=template&id=c8388e62"
import script from "./FullVideo.vue?vue&type=script&lang=js"
export * from "./FullVideo.vue?vue&type=script&lang=js"
import style0 from "./FullVideo.vue?vue&type=style&index=0&id=c8388e62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports